import { Box, ModalHeader, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CustomerCheckResults, CustomerCheckResultType } from '../../../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../../../organisms/trans'

const tKey = TKey('components.verification-failed-modal')

export interface VerificationFailedModalProps {
  checks: CustomerCheckResults
}

export const VerificationFailedModal: FunctionComponent<VerificationFailedModalProps> = ({
  checks,
}) => {
  const { t } = useWriskTranslation()

  const failures = Object.entries(checks)
    .filter(([, value]) => value.result === CustomerCheckResultType.CONSIDER)
    .map(([key]) => key)

  const defaultValue = t(tKey('defaultMessage'))

  const message =
    failures.length === 1 ? (
      <WriskTrans
        t={t}
        i18nKey={tKey('messages', failures[0])}
        defaults={t<string>(tKey('defaultMessage'))}
      />
    ) : (
      defaultValue
    )

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <Typo>{message}</Typo>
    </Box>
  )
}
